import { PRESTACAO_CONTAS_PERMISSIONS } from 'constants/index';
import ListagemContainer from 'pages/comum/containers/listagem.container';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import Title from '../../../components/Title/title.component';
import { LOCAL, STATUS } from '../../../constants';
import PrestacaoContaService from '../../../services/prestacaoContasService';
import { validatePermission } from '../../../utils/permissionHelper';
import FiltroAvancado from './pesquisaAvancadoPrestacaoConta';

const mapStateToProps = state => ({ usuario: state.auth.usuario });

class ListaPrestacoes extends Component {
	columns = [
		{
			id: 0,
			title: 'Processo',
			property: 'numeroProcesso',
			order: 'numeroProcesso',
		},
		{
			id: 1,
			title: 'Ocorrência',
			property: 'nomeOcorrencia',
			order: 'historicoDaca.ocorrencia.nome',
		},
		{
			id: 3,
			title: 'Forma',
			property: 'forma',
			order: 'forma.nome',
		},
		{
			id: 4,
			title: 'Status',
			property: 'status',
			order: 'status.nome',
		},
		{
			id: 5,
			title: 'Local do processo',
			property: 'localProcesso',
			order: 'localProcesso.nome',
		},
	];

	constructor(props) {
		super(props);
		this.child = React.createRef();
		this.state = {
			pesquisaAvancada: false,
			filtro: {
				simplificado: true,
			},
			orderIcon: {
				nome: '',
				icon: undefined,
			},
			inititalOrderIcon: {
				colunaTable: 'historicoDaca.ocorrencia.nome',
				iconOrderDirection: 'fas fa-arrow-down',
			},
		};

		this.handlePesquisaSimplificada = this.handlePesquisaSimplificada.bind(
			this,
		);
		this.handlePesquisaAvancada = this.handlePesquisaAvancada.bind(this);
	}

	get handleFiltroPermissao() {
		const { usuario } = this.props;
		const userPermissions = usuario.soeAcoes;
		let filtro = { simplificado: false };

		if (!userPermissions) {
			return filtro;
		}

		if (
			validatePermission(
				PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_MUNICIPAL,
				userPermissions,
			) && usuario.codLocalidade
		) {
			filtro = {
				...filtro,
				codigoMunicipioList: [usuario.codLocalidade],
			};
		} else if (
			validatePermission(
				PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_REGINONAL,
				userPermissions,
			) && usuario.codLocalidade
		) {
			filtro = {
				...filtro,
				idCrepdecList: [usuario.codLocalidade],
			};
		}
		return filtro;
	}

	getPermissionsToGerenciar(analise) {
		switch (analise.idLocalProcesso) {
			case LOCAL.MUNICIPIO:
				return [
					PRESTACAO_CONTAS_PERMISSIONS.PRESTAR_CONTAS,
					PRESTACAO_CONTAS_PERMISSIONS.REVISAR,
				];
			case LOCAL.CREPDEC:
				return [PRESTACAO_CONTAS_PERMISSIONS.ANALISAR_CREPDEC];
			case LOCAL.DACA:
				return [PRESTACAO_CONTAS_PERMISSIONS.ANALISAR_DACA];
			case LOCAL.SUB_CHEFIA:
				return [PRESTACAO_CONTAS_PERMISSIONS.ANALISAR_SUB_CHEFE];
			default:
				return [];
		}
	}

	showGerenciar(item) {
		const { usuario } = this.props;

		if (!usuario.sub) return false;

		if (item.idStatus === STATUS.ARQUIVADO) return false;

		const permissions = this.getPermissionsToGerenciar(item);

		return validatePermission(permissions, usuario.soeAcoes);
	}

	get actions() {
		return [
			{
				id: 0,
				name: 'Visualizar',
				icon: 'fas fa-search',
				action: item => this.handleVisualizar(item),
			},
			{
				id: 1,
				name: 'Gerenciar item',
				icon: 'fas fa-cogs',
				action: item => this.handleAction(item),
				enabled: item => item.status !== 'Arquivado',
				checkRule: true,
				show: this.showGerenciar.bind(this),
			},
		];
	}

	get handleActions() {
		const { usuario } = this.props;
		const userPermissions = usuario.soeAcoes;

		if (!userPermissions) {
			return this.actionsVisualizar;
		}

		if (
			validatePermission(
				PRESTACAO_CONTAS_PERMISSIONS.PRESTAR_CONTAS,
				userPermissions,
			)
			|| validatePermission(
				PRESTACAO_CONTAS_PERMISSIONS.REVISAR,
				userPermissions,
			)
		) {
			return this.actions;
		}

		return this.actionsVisualizar;
	}

	/* Filtro */
	handlePesquisaSimplificada = () => {
		const prevState = this.state;
		prevState.filtro.simplificado = true;
		prevState.pesquisaAvancada = false;
		prevState.orderIcon = { icon: undefined, nomeColuna: '' };
		this.setState(prevState);
		this.child.current.limpaCampoPesquisaSimplificada();
	};

	handlePesquisaAvancada = () => {
		const prevState = this.state;
		prevState.filtro = {
			...prevState.filtro,
			...this.handleFiltroPermissao,
		};
		prevState.filtro.simplificado = false;

		prevState.pesquisaAvancada = true;
		prevState.orderIcon = { icon: undefined, nomeColuna: '' };

		this.setState(prevState);
	};

	ordenar = (ordem) => {
		const direcaoOrdemFiltro = this.child.current.handleSearchByOrder(
			ordem,
			true,
		);

		if (direcaoOrdemFiltro === 'DESC') {
			this.setState({
				orderIcon: { icon: 'fas fa-arrow-down', nomeColuna: ordem },
			});
		} else {
			this.setState({
				orderIcon: { icon: 'fas fa-arrow-up', nomeColuna: ordem },
			});
		}
	};

	resetIconOrder = () => {
		this.setState({ orderIcon: { icon: undefined, nomeColuna: '' } });
	};

	/*
		AÇÃO DA PRESTAÇÃO DE CONTAS
	*/
	handleAction = (item) => {
		const { history } = this.props;

		if (
			(item.idStatus === STATUS.AGUARDANDO_PRESTACAO_CONTAS
				|| item.idStatus === STATUS.AGUARDANDO_REVISAO)
			&& item.idLocalProcesso === LOCAL.MUNICIPIO
		) {
			history.push(`/prestacaoContas/municipio/${item.id}`);
		} else if (
			(item.idStatus === STATUS.AGUARDANDO_ANALISE
				|| item.idStatus === STATUS.AGUARDANDO_REVISAO)
			&& item.idLocalProcesso === LOCAL.CREPDEC
		) {
			history.push(`/prestacaoContas/crepdec/${item.id}`);
		} else if (
			(item.idStatus === STATUS.AGUARDANDO_ANALISE
				|| item.idStatus === STATUS.AGUARDANDO_REVISAO)
			&& item.idLocalProcesso === LOCAL.DACA
		) {
			history.push(`/prestacaoContas/daca/${item.id}`);
		} else if (
			item.idStatus === STATUS.AGUARDANDO_ANALISE
			&& item.idLocalProcesso === LOCAL.SUB_CHEFIA
		) {
			history.push(`/prestacaoContas/subchefia/${item.id}`);
		} else {
			history.push(`/prestacaoContas/visualizar/${item.id}`);
		}
	};

	handleVisualizar = (item) => {
		const { history } = this.props;
		history.push(`/prestacaoContas/visualizar/${item.id}`);
	};

	pesquisaAvancada(child) {
		const {
			state: { pesquisaAvancada, filtro },
			props: { usuario },
		} = this;
		const filtroAvancado = {
			...filtro,
			...this.handleFiltroPermissao,
		};
		return (
			pesquisaAvancada && (
				<FiltroAvancado
					userInfo={usuario}
					filtro={filtroAvancado}
					handlePesquisaSimplificada={this.handlePesquisaSimplificada}
					serviceSearch={(values) => {
						this.setState({ pesquisaAvancada: { ...values } });
						child.current.manualSearch(
							PrestacaoContaService.findBySearch,
							values,
						);
					}}
					resetIconOrder={this.resetIconOrder}
				/>
			)
		);
	}

	render() {
		const {
			state: { pesquisaAvancada, orderIcon, inititalOrderIcon },
		} = this;
		return (
			<Fragment>
				<div className='row'>
					<div className='col-md-12'>
						<Title>Prestação de contas</Title>
					</div>
				</div>
				<ListagemContainer
					ref={this.child}
					columns={this.columns}
					actions={this.actions}
					listaTitle='Listagem de prestação de contas'
					pesquisaTitle={null}
					filtroPadrao={this.handleFiltroPermissao}
					servicePaginacao={PrestacaoContaService.findAll}
					serviceSearch={PrestacaoContaService.findBySearch}
					serviceCadastrar={PrestacaoContaService.cadastraDoacao}
					emptyMessage='Não há itens cadastrados.'
					ComponenteCadastrar={null}
					toastMessage='Prestação de contas cadastrada com sucesso'
					searchPlaceHolder='Pesquise por ocorrência'
					pesquisaAvancada={pesquisaAvancada}
					isPesquisaAvancada
					handlePesquisaAvancada={this.handlePesquisaAvancada}
					ordenar={this.ordenar}
					isOrderByGrid
					orderIcon={orderIcon}
					inititalOrderIcon={inititalOrderIcon}
					permission={[PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR]}
				>
					{this.pesquisaAvancada(this.child)}
				</ListagemContainer>
			</Fragment>
		);
	}
}

export default connect(mapStateToProps)(ListaPrestacoes);
